exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header .close[data-v-3dd5ffc2] {\n  width: 30px;\n  /* Adjust the width */\n  height: 30px;\n  /* Adjust the height */\n  line-height: 30px;\n  /* Vertically center the 'X' */\n  font-size: 20px;\n  /* Increase the font size */\n}\n", ""]);

// exports
